import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input, message, Modal, Space } from 'antd'
import React from 'react'
import { useState } from 'react';
import { Imports } from '../../Imports';
import { changeEmployeePassword } from '../../Services/users';

const EmployeePasswordChangeModal = ({ open, close, employee }) => {

    const [password, setPassword] = useState(null)

    const validatePassword = async (password) => {
        try {
            return await Imports
                .validators
                .password
                .validate(password);
        } catch (exc) {
            message.error("Please enter a valid password")
            throw exc;
        }
    }

    const onUpdate = async () => {
        let isValid = await validatePassword(password)
        if (!isValid) return
        let resposne = await changeEmployeePassword({ password, id: employee.id })

        if (resposne?.httpStatus === 200) {
            message.success(resposne?.message)
            close()
            setPassword(null)
        }
    }


    return (
        <Modal
            title="Change Password"
            footer={null}
            open={open}
            onCancel={() => {
                close()
                setPassword(null)
            }}
        >
            <div style={{ marginTop: "-10px", }}>
                <span style={{ fontSize: "12px" }}>Password</span>
                <Input.Password
                    placeholder="input password"
                    value={password}
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={e => setPassword(e.target.value)}
                />
                <div style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}>
                    <span style={{ fontSize: "9px", color: "gray" }}>Password must be eight or more characters long</span>
                    <span style={{ fontSize: "9px", color: "gray" }}>Password must have digits [0-9]</span>
                    <span style={{ fontSize: "9px", color: "gray" }}>Password should have special characters (!,$,#,%,etc)</span>
                    <span style={{ fontSize: "9px", color: "gray" }}>Password should be in upper case characters [A-Z]</span>
                    <span style={{ fontSize: "9px", color: "gray" }}>Password should be in lower case characters [a-z]</span>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button
                        style={{ background: '#2963AD', color: 'white', marginTop: "10px", borderRadius: "5px", cursor: "pointer", border: "none", padding: "10px 20px", fontSize: "12px", opacity: ["", null, undefined]?.includes(password) ? "0.5" : "1" }}
                        onClick={onUpdate}
                        disabled={["", null, undefined]?.includes(password)}
                    >
                        Update
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default EmployeePasswordChangeModal